import React from 'react';
import PropTypes from 'prop-types';
import { ResetPasswordConfirm, ResetPasswordSuccess } from './Steps';
import { Container } from './common';

export function ResetPassword({
  issuer,
  email,
  currentStep,
  handleClose,
  handleSubmit,
}) {
  function handleCurrentStep() {
    let content;

    if (currentStep === 'confirm_send_email') {
      content = (
        <>
          <ResetPasswordConfirm
            handleSubmit={handleSubmit}
            handleClose={handleClose}
            email={email}
          />
        </>
      );
    }

    if (currentStep === 'send_email_success') {
      content = (
        <>
          <ResetPasswordSuccess
            issuer={issuer}
            handleClose={handleClose}
            email={email}
          />
        </>
      );
    }

    return content;
  }

  return <Container type={currentStep}>{handleCurrentStep()}</Container>;
}

ResetPassword.propTypes = {
  issuer: PropTypes.string,
  email: PropTypes.string,
  currentStep: PropTypes.string,
  handleClose: PropTypes.func,
  handleSubmit: PropTypes.func,
};
